interface FormatNameOptions {
  /**
   * Whether to trim only the start of the string or both start and end
   * @default 'both'
   */
  trimMode?: "start" | "both";
  /**
   * Whether to normalize hyphen spacing (remove spaces before/after hyphens)
   * @default true
   */
  normalizeHyphens?: boolean;
}

function capitalizeFirstLetter(input: string): string {
  if (input.length === 0) {
    return input;
  }

  return input.charAt(0).toUpperCase() + input.slice(1);
}

export function formatName(input: string, options?: FormatNameOptions): string {
  const trimMode = options?.trimMode ?? "both";
  const shouldNormalizeHyphens = options?.normalizeHyphens ?? true;

  const trimmedInput = trimMode === "start" ? input.trimStart() : input.trim();
  const normalizedInput = shouldNormalizeHyphens
    ? normalizeHyphenSpacing(trimmedInput)
    : trimmedInput;

  return capitalizeFirstLetter(normalizedInput);
}

/**
 * Removes spaces before and after hyphens in a name.
 * Example: "Mary - Jane" → "Mary-Jane"
 */
function normalizeHyphenSpacing(input: string): string {
  return input.replace(/\s*-\s*/g, "-");
}
